export default __webpack_public_path__ + "static/media/cover.f2269e6e.png";